import React from 'react'

export const Cairtean = () => {
  return (
    <div>More details to come...</div>
  )
}
